<p-panel header="{{'cs.psv.person.profile.aboutMe.header' | hisUi}}" id="aboutMe" *ngIf="!showAboutMe">
	<div class="infoMessage">
		<span>{{'cs.psv.person.profile.aboutMe.info' | hisUi}}</span>
	</div>
	<div class="clearAndSpace"></div>
        <his-plam [showLabelTop]="true" *ngIf="aboutMeObject">
        <textarea #content rows="10"
            [ngModel]="aboutMeObject.entrytext"
            [hisObject]="aboutMeObject" hisAttribute="entrytext"
			hisDdKey="cs.psv.person.profile.aboutMe"
			class="textareaWidth100">
		</textarea>
	</his-plam>
</p-panel>

<div class="clearAndSpace"></div>

<p-panel header="{{'cs.psv.person.profile.researchField.header' | hisUi}}" id="researchField" *ngIf="!showResearchFields">
	<div class="clearAndSpace"></div>
	<his-plam [showLabelTop]="true" key="cs.psv.person.profile.researchField.header">
		<his-editor #content class="tenRowsHeight"
			[data]="researchFieldsObject?.entrytext"
			hisDdKey="cs.psv.person.profile.researchFields"
            [hisObject]="researchFieldsObject" hisAttribute="entrytext"
            (translationLanguageChanged)="translationLanguageChanged($event, researchFieldsObject)"
			toolbar="none">
		</his-editor>
	</his-plam>

	<div class="clearAndSpace"></div>
</p-panel>

<div class="clearAndSpace"></div>

<p-panel header="{{'cs.psv.person.profile.teachingField.header' | hisUi}}" id="teachingField" *ngIf="!showTeachingFields">
	<div class="clearAndSpace"></div>
    <his-plam [showLabelTop]="true" key="cs.psv.person.profile.teachingField.header">
		<his-editor #content
			[data]="teachingFieldsObject?.entrytext"
			hisDdKey="cs.psv.person.profile.teachingFields"
            [hisObject]="teachingFieldsObject" hisAttribute="entrytext"
            (translationLanguageChanged)="translationLanguageChanged($event, teachingFieldsObject)"
			toolbar="none">
		</his-editor>
	</his-plam>

	<div class="clearAndSpace"></div>
</p-panel>
